import { Component, Input, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs';
import { IconHover, StorageName } from '../../../../../shared/enum/common-enum';
import { ResponseModel } from '../../../../../shared/models/response-model.model';
import { CommonService } from '../../../../../shared/services/common.service';
import { AgGridDataModelMappedProducts, MasterModalTitle } from '../../masters.model';
import { MastersService } from '../../masters.service';
import { StorageService } from '../../../../../shared/services/storage.service';
import { AgGridService } from '../../../../../shared/common-components/ag-grid/ag-grid.service';
import { AgGridI, PaginationModel } from '../../../../../shared/common-components/ag-grid/ag-grid.model';
import { CommonFilterService } from '../../../../../shared/services/common-filter.service';
import { AgGridComponent } from '../../../../../shared/common-components/ag-grid/ag-grid.component';
import { CustomSelect2Component } from '../../../../../shared/common-components/custom-select2/custom-select2.component';

@Component({
  selector: 'app-add-edit-category',
  templateUrl: './add-edit-category.component.html',
  styleUrls: ['./add-edit-category.component.scss']
})
export class AddEditCategoryComponent extends CommonService{
  @Input() modalTitle: string;
  @Input() data : any;
  @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>
  @ViewChild('parentCategory') parentCategory: CustomSelect2Component;
  masterModalTitle = MasterModalTitle;
  agGridDataModelMappedProducts : AgGridI;
  gridApiMappedProducts  : any;
  storageName = StorageName;
  insertCategoryRequestModel : any = {active:true};
  categoryDropdown: any= [];
  apiRequestModel: any = {};
  apiRequestStorageName=StorageName.APIREQUEST_ADMINISTRATION_CATEGORY_MAPPED_PRODUCTS_GRID;
  paginationStorageName = StorageName.PAGINATION_ADMINISTRATION_CATEGORY_MAPPED_PRODUCTS_GRID;
  currentHoverEffect = IconHover.Pink;
  pagination = new PaginationModel();

  constructor(public activeModal: NgbActiveModal,
    public mastersService           : MastersService,
    public storageService           : StorageService,
    public renderer                 : Renderer2,
    public toaster                  : ToastrService,
    public agGridService            : AgGridService,
    public commonFilterService      : CommonFilterService,
  ) 
  {
    super(renderer)
  }
  ngOnInit(): void {
    this.categoryDropdown = (this.storageService.retrieve(StorageName.CATEGORY_DROPDOWN) || [])?.filter(x => x?.extra1 === (this.storageService.retrieve(StorageName.LAYOUT_DETAILS)?.branchId?.toString() || ''));  
    this.agGridDataModelMappedProducts = AgGridDataModelMappedProducts;
    if(this.data?.editCategory?.id) this.insertCategoryRequestModel = this.data?.editCategory;    
  }

  ngAfterViewInit(): void {
    setTimeout(()=>{
      this.parentCategory?.setDataSource(this.categoryDropdown);
      if(this.insertCategoryRequestModel?.parentCategoryId)this.parentCategory?.setDropdownText(this.insertCategoryRequestModel?.parentCategoryId.toString());
    },0)
  }
  assignParentCategoryId(parentCategoryId){
    this.insertCategoryRequestModel.parentCategoryId = parentCategoryId == '' ? 0 : parentCategoryId;
  }

  addEditCategoryList(){
    if (this.isBlankUndefinedOrNull(this.insertCategoryRequestModel?.name))
      return this.toaster.error('Name is required');

    if (this.modalTitle === this.masterModalTitle.AddCategory || (!this.insertCategoryRequestModel?.id)) {
      this.inserCategoryList();
    } else {
      this.updateCategoryList();
    }
  }

  inserCategoryList() {    
    this.mastersService.insertCategory(this.insertCategoryRequestModel)
    .pipe(catchError((err) => this.handleError(err)))
    .subscribe((res) => {
      if (res?.isSuccess) {
        this.toaster.success(res?.message);
        this.activeModal.close(res);
      } else {
        this.toaster.error(res?.errors[0]);
      }
    });
  }

  updateCategoryList() {
    this.mastersService
      .updateCategory(this.insertCategoryRequestModel)
      .pipe(catchError((err) => this.handleError(err)))
      .subscribe((res: ResponseModel) => {
        if (res?.isSuccess) {
          this.activeModal.close(res);
          this.toaster.success(res?.message); 
        } else {
          this.toaster.error(res?.errors[0]);
        }
      });
  }
  onGridReady(event){
    this.gridApiMappedProducts = event;  
    this.storeChangedPagination();
    this.getAllMappingProductsList();
  }
  getAllMappingProductsList() {
    this.showLoading(this.gridApiMappedProducts);
    this.apiRequestModel = this.storageService?.retrieve(this.apiRequestStorageName);
    this.apiRequestModel.categoryId = this.data?.editCategory?.id;
    this.mastersService.getAllProductsByCategoryId(this.apiRequestModel).subscribe({
      next:(res)=>{
        this.commonFilterService.processServersideApiResponse(res,this.grids.first,this.gridApiMappedProducts,this.pagination,this.apiRequestModel.getAll,false); 
      },
      error:(err)=>{
        this.hideLoading(this.gridApiMappedProducts);
        this.gridApiMappedProducts?.api?.setRowData([]);
      }
    })
  }

  onPagination(pagination: PaginationModel) {
    this.storeChangedPagination(pagination);
    this.getAllMappingProductsList();
  }

  storeChangedPagination(paginationModel: PaginationModel = new PaginationModel()) {
    this.pagination = this.commonFilterService?.storeChangedPagination(paginationModel, this.pagination,this.paginationStorageName,this.apiRequestStorageName);
  }

  onSortIconClick(event) {
    this.commonFilterService.storeChangedSortList(this.agGridDataModelMappedProducts?.sortStorageName, this.apiRequestStorageName);
    this.apiRequestModel = this.storageService.retrieve(this.apiRequestStorageName);
    this.getAllMappingProductsList();
  }

  
}
